module.exports = __webpack_public_path__ + "static/media/MissionCost.4d5106c0.jpg";